module.exports = __webpack_public_path__ + "img/Back Door.71696a85.png";